"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row_1 = require("../../components/Row");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const FormSection_1 = require("../../../utils/FormSection");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
class EventDelay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailAnimation: 'ltr',
            isEditingDelayValue: false,
            isViewingUnitSelector: false,
            temporaryDelayUnit: undefined,
            temporaryDelayValue: undefined,
        };
        this.closeDetail = this.closeDetail.bind(this);
        this.getButtonLeft = this.getButtonLeft.bind(this);
        this.getDelayCopy = this.getDelayCopy.bind(this);
        this.getDelay = this.getDelay.bind(this);
        this.getPopoverModalProps = this.getPopoverModalProps.bind(this);
        this.getPopoverNavbarProps = this.getPopoverNavbarProps.bind(this);
        this.setState = this.setState.bind(this);
        this.getUnitCopy = this.getUnitCopy.bind(this);
    }
    closeDetail() {
        this.setState({ detailAnimation: 'rtl' }, () => setTimeout(() => this.setState({
            detailAnimation: 'ltr',
            isViewingUnitSelector: false,
        }), 150));
    }
    getChangeButton() {
        const { automatedDelay, device } = this.props;
        const { value } = automatedDelay;
        if (value === 0) {
            return null;
        }
        switch (device) {
            case 'Desktop':
                return (React.createElement("div", { key: "event-delay-add" },
                    React.createElement(src_1.Button, { text: "Change", type: "regular", style: {
                            innerStyle: {
                                fontSize: 17,
                            },
                            outerStyle: {
                                height: null,
                                lineHeight: '24px',
                            },
                        }, mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        } })));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "event-delay-add", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getDelay() {
        const { automatedDelay: { value }, } = this.props;
        return (React.createElement(src_1.Text, { text: this.getDelayCopy(), label: true, size: "large", textStyle: { color: value > 0 ? src_1.charcoal : src_1.titanium } }));
    }
    getDelayCopy() {
        const { unit, value } = this.props.automatedDelay;
        switch (unit) {
            case 'd':
                return `${value} day${value !== 1 ? 's' : ''}`;
            case 's':
                return `${value} second${value !== 1 ? 's' : ''}`;
            case 'm':
                return `${value} minute${value !== 1 ? 's' : ''}`;
            case 'h':
                return `${value} hour${value !== 1 ? 's' : ''}`;
            default:
                return '';
        }
    }
    getButtonLeft(handleClose) {
        const { device } = this.props;
        const { isViewingUnitSelector } = this.state;
        if (!isViewingUnitSelector) {
            return (React.createElement("div", { onClick: handleClose },
                React.createElement(src_1.Button, { text: "Cancel", type: "disabled", style: {
                        innerStyle: {
                            fontSize: 17,
                            padding: 0,
                            color: src_1.steel,
                        },
                        outerStyle: {
                            height: 24,
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                            marginLeft: 16,
                        },
                    } })));
        }
        return (React.createElement("div", { style: {
                display: 'flex',
                marginLeft: device === 'Mobile' ? 16 : 8,
            }, onClick: this.closeDetail },
            React.createElement(src_1.ChevronLeftIcon, { fill: "#000" }),
            React.createElement(src_1.Button, { text: "Back", type: "disabled", style: {
                    innerStyle: {
                        fontSize: 17,
                        padding: 0,
                        color: src_1.steel,
                    },
                    outerStyle: {
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        background: 'none',
                    },
                } })));
    }
    getPopoverModalProps(handleClosePopoverModal) {
        return {
            placement: 'left',
            navBarProperties: Object.assign({ id: 'event-delay-nav-bar', title: '', arrowColors: {
                    primary: src_1.cloud,
                    secondary: src_1.white,
                    border: src_1.titanium,
                }, style: {
                    containerStyle: {
                        borderRadius: '3px 3px 0px 0px',
                    },
                } }, this.getPopoverNavbarProps(handleClosePopoverModal)),
            overlayClickHandler: () => this.setState({
                isViewingUnitSelector: false,
                detailAnimation: 'ltr',
                temporaryDelayUnit: null,
                temporaryDelayValue: null,
            }),
        };
    }
    getPopoverNavbarProps(handleClosePopoverModal) {
        const { automatedDelay, updateAutomatedCampaignTrigger } = this.props;
        const { unit, value } = automatedDelay;
        const { temporaryDelayUnit, temporaryDelayValue } = this.state;
        return {
            customLeftElem: this.getButtonLeft(handleClosePopoverModal),
            buttonLeftCallback: () => {
                handleClosePopoverModal();
                this.setState({
                    isEditingDelayValue: false,
                    temporaryDelayUnit: undefined,
                    temporaryDelayValue: undefined,
                });
            },
            buttonRight: 'Done',
            buttonRightCallback: () => {
                handleClosePopoverModal();
                updateAutomatedCampaignTrigger({
                    unit: temporaryDelayUnit || unit,
                    value: temporaryDelayValue || value,
                });
                this.setState({
                    isEditingDelayValue: false,
                    isViewingUnitSelector: false,
                    temporaryDelayUnit: undefined,
                    temporaryDelayValue: undefined,
                });
            },
        };
    }
    getUnitCopy() {
        const { automatedDelay } = this.props;
        const { unit } = automatedDelay;
        const { temporaryDelayUnit } = this.state;
        switch (temporaryDelayUnit || unit) {
            case 'd':
                return 'Days';
            case 'h':
                return 'Hours';
            case 'm':
                return 'Minutes';
            default:
                return '';
        }
    }
    render() {
        const { automatedDelay, device, updateAutomatedCampaignTrigger } = this.props;
        const { unit, value } = automatedDelay;
        const { detailAnimation, isEditingDelayValue, isViewingUnitSelector, temporaryDelayUnit, temporaryDelayValue } = this.state;
        return (React.createElement(FormSection_1.default, { device: device },
            React.createElement(src_1.Text, { size: "h2", text: "Once triggered, send notification..." }),
            React.createElement(Row_1.default, { onClick: () => updateAutomatedCampaignTrigger({ unit: 's', value: 0 }) },
                React.createElement(src_1.Text, { size: "large", text: "Immediately" }),
                React.createElement(src_1.RadioButton, { selected: value === 0, style: { outerStyle: { height: 18, width: 18 } } })),
            React.createElement(Row_1.default, { onClick: () => value === 0 && updateAutomatedCampaignTrigger({ unit: 'd', value: 1 }) },
                React.createElement(src_1.Text, { size: "large", text: "After a delay of..." }),
                React.createElement(src_1.RadioButton, { selected: value > 0, style: { outerStyle: { height: 18, width: 18 } } })),
            value > 0 ? (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: {
                    id: 'automated-delay',
                    media: device,
                    text: 'a',
                    fieldStyle: {
                        marginTop: 0,
                        padding: device === 'Desktop' ? '24px 0 23px' : 0,
                        minHeight: 'none',
                        width: '100%',
                    },
                    isEditingText: false,
                    customSecondaryText: this.getDelay(),
                }, presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: "automated-delay", popoverModalProps: this.getPopoverModalProps, popoverNavbarProps: this.getPopoverNavbarProps, editButton: this.getChangeButton() },
                React.createElement("div", { style: {
                        padding: '0 16px',
                        width: device === 'Mobile' ? '100%' : 352,
                        height: device !== 'Mobile' ? 169 : 216,
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        overflow: 'hidden',
                    } },
                    React.createElement("div", { onClick: () => this.setState({ isEditingDelayValue: true }), style: {
                            height: device === 'Mobile' ? 72 : 55,
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        React.createElement(src_1.Text, { id: "event-delay-input", size: device === 'Mobile' ? 'large' : 'medium', text: temporaryDelayValue ? temporaryDelayValue.toString() : `${value}`, contentEditable: isEditingDelayValue, onBlurChange: true, handleBlurChange: () => this.setState({
                                isEditingDelayValue: false,
                            }), onInputChange: (str) => this.setState({
                                temporaryDelayValue: parseInt(str.replace(/\D/g, ''), 10),
                            }) })),
                    React.createElement("div", { style: {
                            width: '100%',
                            height: 1,
                            backgroundColor: src_1.titanium,
                        } }),
                    React.createElement("div", { onClick: () => value > 0 &&
                            this.setState({
                                isViewingUnitSelector: true,
                            }), style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            height: device === 'Mobile' ? 72 : 56,
                            borderBottom: `1px solid ${src_1.titanium}`,
                        } },
                        React.createElement(src_1.Text, { size: device === 'Mobile' ? 'large' : 'medium', text: this.getUnitCopy() }),
                        React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium })),
                    isViewingUnitSelector && (React.createElement("div", { style: {
                            height: 'auto',
                            width: '100%',
                            backgroundColor: 'white',
                            animation: `${detailAnimation} 150ms ease-in-out`,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        } },
                        React.createElement(src_1.SelectableList, { device: device },
                            React.createElement("div", { key: "event-delay-minutes", onClick: () => this.setState({
                                    temporaryDelayUnit: 'm',
                                }), style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: device === 'Mobile' ? 72 : 55,
                                } },
                                React.createElement(src_1.Text, { text: "Minutes", size: "medium" }),
                                React.createElement(src_1.RadioButton, { selected: temporaryDelayUnit ? temporaryDelayUnit === 'm' : unit === 'm', style: {
                                        outerStyle: {
                                            height: 18,
                                            width: 18,
                                        },
                                    } })),
                            React.createElement("div", { key: "event-delay-hours", onClick: () => this.setState({
                                    temporaryDelayUnit: 'h',
                                }), style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: device === 'Mobile' ? 72 : 55,
                                } },
                                React.createElement(src_1.Text, { text: "Hours", size: "medium" }),
                                React.createElement(src_1.RadioButton, { selected: temporaryDelayUnit ? temporaryDelayUnit === 'h' : unit === 'h', style: {
                                        outerStyle: {
                                            height: 18,
                                            width: 18,
                                        },
                                    } })),
                            React.createElement("div", { key: "event-delay-days", onClick: () => this.setState({
                                    temporaryDelayUnit: 'd',
                                }), style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    height: device === 'Mobile' ? 72 : 55,
                                } },
                                React.createElement(src_1.Text, { text: "Days", size: "medium" }),
                                React.createElement(src_1.RadioButton, { selected: temporaryDelayUnit ? temporaryDelayUnit === 'd' : unit === 'd', style: {
                                        outerStyle: {
                                            height: 18,
                                            width: 18,
                                        },
                                    } })))))))) : (React.createElement(Row_1.default, null,
                React.createElement(src_1.Text, { textStyle: { color: src_1.titanium }, size: "large", text: "1 day" })))));
    }
}
const mapStateToProps = (state) => ({
    automatedDelay: reducers_1.getEditableCampaignAutomatedCampaignTrigger(state).delay,
});
const mapDispatchToProps = (dispatch) => ({
    updateAutomatedCampaignTrigger: (delay) => {
        dispatch(actions_1.updateAutomatedCampaignTrigger({ delay }));
    },
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EventDelay);
